import { initalizeAirbrakeNotifier } from "@stadium/services/airbrake";
import {
  APP_NODE_ENV,
  APP_ENV,
  AIRBRAKE_PROJECT_KEY,
  AIRBRAKE_PROJECT_ID,
} from "@constants/env-variables";

const isDevelopment = APP_NODE_ENV === "development";
const appEnv = APP_ENV;
const BLACKLISTED_KEYS = [
  /password/i,
  /secret/i,
  /token/i,
  /credit_card/i,
  /gateway/i,
  /exp_/i,
  /last4/i,
];
const CONFIG = {
  projectId: AIRBRAKE_PROJECT_ID,
  projectKey: AIRBRAKE_PROJECT_KEY,
  environment: APP_ENV,
  keysBlockList: BLACKLISTED_KEYS,
};

let airbrakeNotifier = isDevelopment
  ? {
      notify: () => {},
    }
  : initalizeAirbrakeNotifier({ config: CONFIG });

const IGNORED_ERRORS = [
  /request aborted/i,
  /appendchild.*intercom/i,
  /exception invoking jsconstructor/i,
  /promise resolver is not a function/i,
  /extension context invalidated/i,
  /_AutofillCallbackHandler/i,
  /Object Not Found Matching Id/i,
  /gCrWeb/i,
  /url\.startsWith/i,
];

if (!isDevelopment) {
  airbrakeNotifier.addFilter((notice) => {
    notice.context.environment = appEnv;

    const allErrorsBelongToIgnoredErrors = notice.errors.every((err) => {
      return IGNORED_ERRORS.some((errRegex) => errRegex.test(err.message));
    });

    if (allErrorsBelongToIgnoredErrors) {
      /* ignoring errors */
      return null;
    }

    return notice;
  });
}

export default airbrakeNotifier;
